enum EAppRoute {
	Partner = '/:partner',
	BusinessAcquisition = `${Partner}/business-acquisition`,
	BusinessAcquisitionWithId = `${Partner}/business-acquisition/:businessEntityId`,
	Debts = `${Partner}/debts`,
	BankStatements = `${Partner}/bank-statements`,
	UploadAttachments = `${Partner}/upload-attachments`,
	CompleteApplication = `${Partner}/complete-application`,
	CompleteApplicationWithId = `${Partner}/complete-application/:applicationId`,
	// OwnerInfo = `${Partner}/owner-info`,
	Thanks = '/thanks',
	NotFound = '404',
}

export default EAppRoute;
